import { LookerDashboardTypeEnum } from './dashboard.enums';

/**
 * Superset dashboard UUID for each portal dashboard. These are the dashboards' own UUIDs, fixed in the
 * saymine/superset repo (assets/dashboards/<uuid>.yaml) and identical in every environment; they are not embed
 * UUIDs. The backend resolves the embed UUID at runtime (POST api/dashboards/{uuid}/token), so a re-embed or a
 * Superset upgrade needs no frontend change. Only adding or replacing a dashboard does.
 */
export const DASHBOARD_UUIDS: Readonly<Record<LookerDashboardTypeEnum, string>> = {
    [LookerDashboardTypeEnum.DSR]: '2bf35af8-1a5e-4fc1-a556-600f6ef4ddde',
    [LookerDashboardTypeEnum.DsrAuditLog]: '1563993b-f687-4e8c-be09-75a1fb1fac81',
    [LookerDashboardTypeEnum.DsrCaliforniaDrop]: '05adbda2-e5bf-4318-a181-f04d8c31279c',
    [LookerDashboardTypeEnum.Compliance]: 'e63a50ad-dcda-410b-ba74-87e76df560fb',
    [LookerDashboardTypeEnum.Risk]: 'f7797efb-68da-4485-af86-af5c8b09c1d3',
    [LookerDashboardTypeEnum.AiGov]: '578bee07-264e-4fa0-91d9-22673f752b82',
    [LookerDashboardTypeEnum.TPRM]: 'c2650903-423c-488a-9abd-2bdf2c864437',
    [LookerDashboardTypeEnum.CMP]: '5928f40d-0b30-4398-84e4-753e2cd6cb95',
    [LookerDashboardTypeEnum.GOV]: 'bfe808ce-da2f-4f40-8beb-9c3d70b05894',
};
